import { IconButton } from '@mui/material';
import './MobileMenu.css'
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { useState } from 'react';
// import firmcraftlogo from '../../assets/old/kmpsfullogo.png'
import kmpslogo from '../../assets/kmpslogo.png'
import {Link} from 'react-router-dom'

const MobileMenu=()=>{

    const [openMenu, setopenMenu] = useState(false)
    return(
        <div className='mobilemenu-main'>
            <div className='mobile-menu-logo-container'>
                    <div className='mobile-menu-logo'>
                        <img src={kmpslogo} alt='../../assets/kmpslogo.png'/>
                    </div>
                            <div className='mobile-logo-text-container'>
                            <p className='mobile-logo-text-header'>KMPS DIGI INFRA PRIVATE LIMITED</p>
                            <p className='mobile-logo-text-sub-header'>DRIVING THE FUTURE WITH EMBEDDED INTELLIGENCE</p>
                        </div>
            </div>
            
            <div className='mobile-menu-icon'>
                <IconButton onClick={()=>setopenMenu(!openMenu)}>
                 {openMenu ? <CloseRoundedIcon style={{fontSize:"2rem"}}/> :<MenuRoundedIcon style={{fontSize:"2rem"}}/>  }   
                </IconButton>
            </div>
            <div className='mobile-menu-list-container' style={{display:openMenu?"block":"none"}}>
            <Link to={'/'} style={{textDecoration:"none", textTransform:"none"}} >
                <div className='mobile-menu-list-item'>Home</div>
            </Link>
            {/* <Link to={'/'} style={{textDecoration:"none", textTransform:"none"}} >
            <div className='mobile-menu-list-item'>About</div>
            </Link> */}
            <Link to={'/service'} style={{textDecoration:"none", textTransform:"none"}} >
            <div className='mobile-menu-list-item'>Solutions</div>
            </Link>
            <Link to={'/clients'} style={{textDecoration:"none", textTransform:"none"}} >
            <div className='mobile-menu-list-item'>Clients</div>
            </Link>
            {/* <Link to={'/projects'} style={{textDecoration:"none", textTransform:"none"}} >
            <div className='mobile-menu-list-item'>Products</div>
            </Link> */}
            {/* <Link to={'/'} style={{textDecoration:"none", textTransform:"none"}} >
            <div className='mobile-menu-list-item mobile-menu-list-item-subitem'>Pages<AddRoundedIcon style={{fontSize:"1rem"}}/></div>
            </Link> */}
            <Link to={'/contactus'} style={{textDecoration:"none", textTransform:"none"}} >
            <div className='mobile-menu-list-item'>Contact</div>
            </Link>
            </div>
        </div>
    )
}

export default MobileMenu;